module.exports = __webpack_public_path__ + "static/media/logoNew.fdf70ce3.png";